import { render, staticRenderFns } from "./Ecomerce.vue?vue&type=template&id=3b24d9eb"
import script from "./Ecomerce.vue?vue&type=script&lang=js"
export * from "./Ecomerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports